export default __webpack_public_path__ + "static/media/haraka-logo-white.b4808251.png";